<template>
  <el-popover
      trigger="hover"
      placement="bottom"
      :visible-arrow="false"
      width="232"
      popper-class="person-info-popover"
      @show="getDetail"
  >

    <div class="size12">

      <div
          class="popover-header"
          :class="{'popover-header-blue':personInfo.color==='blue','popover-header-red':personInfo.color==='red'}"
      >
        <div class="size16 popover-header-title">{{personInfo.title}}</div>
        <div class="flex align-center justify-between">
          <div>{{personInfo.tip}}</div>
          <gj-button class="recharge weight600" round @click="$router.push('/setting/erp-package')">去充值</gj-button>
        </div>
      </div>

      <div class="popover-order color999" v-if="personInfo.orderItems&&personInfo.orderItems.length>0">
        <div
            v-for="(item,key) in personInfo.orderItems"
            :key="key"
            class="popover-order-item flex justify-between align-center"
        >
          <span>{{item.text}}</span>
          <div>
            <span :class="{'colorRed':item.red}">{{item.num}}</span>
            <span v-if="item.goBuy" type="text" class="colorBlue" style="margin-left: 5px; cursor: pointer;" @click="$router.push('/setting/erp-package')">去购买></span>
          </div>
        </div>
      </div>
      <div class="popover-btn" @click="demoEnvironment()">
        <i class="iconfont icona-yanshi1"></i>
        查看演示环境
      </div>
      <div class="popover-btn" v-if="isNewUserTask && (guideVisible || (!guideVisible && isShowNoviceGuide))"  @click="openNoviceGuide()" >
        <i class="iconfont iconxinshourenwu"></i>
        新手任务
      </div>
      <div class="popover-btn" @click="personalCenter">
        <i class="iconfont icona-Group283"></i>
        个人中心
      </div>
      <div class="popover-btn justify-between" @click="$emit('cutNavState')">
        <div class="flex">
          <i class="iconfont icona-Group284"></i>
          导航布局设置
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="popover-btn" style="border-radius: 0 0 4px 4px;" @click="logout">
        <i class="iconfont icona-Group285"></i>
        退出账号
      </div>
    </div>


    <div slot="reference" class="reference flex align-center">
      <el-avatar size="small" :src="userUrl" class="nav-bar--right__user--avatar"></el-avatar>
      <span class="nav-bar--right__user--name size14">{{ userInfo.name }}</span>
    </div>
  </el-popover>
</template>

<script>
import {getTaskList, postFinishHandleTask} from "@/api/system";
import {mapGetters} from "vuex";
import {USER_LOGOUT} from "@/store/action-types";
import {USER_SET_MESSAGE, USER_SET_POLLING, SET_KEEP_ALIVE_VIEWS, SET_NAV_MENU_TABS} from "@/store/mutation-types";
import AppCutNavModal from "@/views/layout/app-nav-bar/modal/app-cut-nav-modal";
import {getTenantOrderDetailed} from "@/api/user";
import {getPersonalInfo} from "@/api/personal-center";
import { getTaskTenant } from "@/api/guide";
import {getAllMap} from "@/api/dashboard";
import {isMeaningful} from "@/utils/common";
import NoviceGuide from '@/views/modules/home/novice-guide/novice-guide'

export default {
  name: "person-info-popover",
  data() {
    return {
      userUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      data:{}
    }
  },
  watch:{
    $route:{
      handler(){
        getPersonalInfo().then(result => {
          if (isMeaningful(result.wxHeadImageAddress)&&result.wxHeadImageAddress!=='') {
            this.userUrl = result.wxHeadImageAddress;
          }else {
            this.userUrl = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'isNewUserTask', 'guideVisible', 'isShowNoviceGuide']),
    personInfo(){
      let personInfo = {
        orderItems:[]
      };
      // oldNotPayUser：未付费老客户，newNotPayUser：未付费新客户，payUser：付费客户
      if(this.data.userType === 'oldNotPayUser'){
        personInfo = {
          title:this.data.usableOrder>=0?'免费专享客户':'您的账号已超出免费订单量',
          tip:this.data.usableOrder>=0?'欢迎使用积加ERP':this.data.days+'天后将无法使用系统',
          color:this.data.usableOrder>=0?'blue':'red',
          orderItems:[
            {text:'每日免费订单量',num:this.data.freeOrder,red:this.data.usableOrder<0},
            {text:'已使用订单总量',num:this.data.useOrder},
            {text:'邮件剩余量',num: this.data.remainingEmail, red: this.data.remainingEmail == 0, goBuy: this.data.remainingEmail <= 1000}, // 有客服权限账号展示
            {text:'积点剩余量',num: this.data.remainingVirtual, red: this.data.remainingVirtual == 0, goBuy: this.data.remainingVirtual <= 1000}, // 有客服权限账号展示
          ],
          ...this.data
        }
      }else if(this.data.userType === 'newNotPayUser'){
        // 新客户
        if(this.data.freeOrder === 0 && this.data.giftOrder === 0){
          personInfo = {
            title:'您还未购买套餐',
            tip:'欢迎使用积加ERP',
            color:'blue'
          }
        }else {
          personInfo = {
            title:this.data.usableOrder>0?'免费专享客户':'您的账号已超出免费订单量',
            tip:this.data.usableOrder>0?'欢迎使用积加ERP':this.data.days+'天后将无法使用系统',
            color:this.data.usableOrder>0?'blue':'red',
            orderItems:[
              {text:'已使用订单量',num:this.data.useOrder,red:this.data.usableOrder<=0},
              {text:'赠送订单量',num:this.data.giftOrder},
              {text:'邮件剩余量',num: this.data.remainingEmail, red: this.data.remainingEmail == 0, goBuy: this.data.remainingEmail <= 1000}, // 有客服权限账号展示
              {text:'积点剩余量',num: this.data.remainingVirtual, red: this.data.remainingVirtual == 0, goBuy: this.data.remainingVirtual <= 1000}, // 有客服权限账号展示
            ],
            ...this.data
          }
        }
      }else if(this.data.userType === 'payUser'){
        personInfo = {
          title:this.data.usableOrder>0?'VIP客户':'您的账号订单量不足',
          tip:'',
          color:this.data.usableOrder>0?'blue':'red',
          orderItems:[
            {text:'剩余可使用订单量',num:this.data.usableOrder,red:this.data.usableOrder<=500},
            {text:'已使用订单总量',num:this.data.useOrder},
            {text:'邮件剩余量',num: this.data.remainingEmail, red: this.data.remainingEmail == 0, goBuy: this.data.remainingEmail <= 1000}, // 有客服权限账号展示
            {text:'积点剩余量',num: this.data.remainingVirtual, red: this.data.remainingVirtual == 0, goBuy: this.data.remainingVirtual <= 1000}, // 有客服权限账号展示
            // {text:'关怀邮件剩余量',num: 0, red: true, goBuy: true}, // 有客服权限账号展示
            // {text:'站外邮件剩余量',num: 0, red: true, goBuy: true } // 有客服权限账号展示
          ],
          ...this.data
        }
        if (this.data.freeOrder > 0) {
          personInfo.orderItems.unshift({text:'每日免费订单量',num:this.data.freeOrder})
        }
        //剩余订单量提示
        if(this.data.usableOrder>500){
          personInfo.tip = '欢迎使用积加ERP'
        }else if(this.data.usableOrder<=500&&this.data.usableOrder>0){
          personInfo.tip = '订单剩余量即将不足';
          if(this.data.freeOrder > 0) {
            personInfo.orderItems.shift()
          }
          personInfo.orderItems = personInfo.orderItems.concat([
            {text:'每日免费订单量',num:this.data.freeOrder},
            {text:'赠送订单总量',num:this.data.giftOrder},
          ])
        }else{
          personInfo.tip = this.data.days+'天后将无法使用系统'
        }
      }

      return personInfo
    }
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail(){
      getTenantOrderDetailed().then(res=>{
        this.data = res;
        // this.data = {
        //   freeOrder: 10,// 每日免费订单数
        //   giftOrder: 110,// 赠送订单数
        //   useOrder: 110,// 累计已用订单数
        //   usableOrder: -144,// 累计可用订单数
        //   userType: 'payUser',//租户付费类型，oldNotPayUser：未付费老客户，newNotPayUser：未付费新客户，payUser：付费客户
        //   days: 13 // 失效天数，默认为null
        // }
      })
    },
    logout() {
      //清除缓存
      this.$cache.deleteCache();
      window.sessionStorage.removeItem('firstIn');
      this.$store.dispatch(USER_LOGOUT)
          .then(() => {
            // 退出登录时将消息数清零,以免登录时重新登录时会记住前一个的记录
            this.$store.commit(USER_SET_MESSAGE, {type: 'system', value: 0});
            this.$store.commit(USER_SET_MESSAGE, {type: 'account', value: 0});
            this.$store.commit(USER_SET_MESSAGE, {type: 'operation', value: 0});
            this.$store.commit(USER_SET_POLLING, false);
            const newTabs = [
              {
                fullPath: "/dashboard",
                name: "Dashboard",
                path: "/dashboard",
                closable: false,
                fixed: false,
              },
            ];
            this.$store.commit(SET_NAV_MENU_TABS, newTabs);
            this.$store.commit(SET_KEEP_ALIVE_VIEWS, []);

            this.$gjMessage({
              message: '退出成功',
              type: 'success',
              duration: 800
            });
          })
          .catch(() => {
            this.$gjMessage.error('退出失败');
          })
    },
    personalCenter() {
      this.$router.push({
        path: '/personal-center/personal-center'
      })
    },
    openNoviceGuide() {
      this.$gjCreate(NoviceGuide)
    },
    // 查看跳转demo环境
    demoEnvironment() {
      window.open(`http://mdemonew.gerpgo.cn/manager-login?isAutoLogin=1`);
    }
  }
}
</script>

<style scoped lang="scss">
.nav-bar--right__user--avatar {
  height: 24px;
  width: 24px;
}
.nav-bar--right__user--name {
  line-height: 1;
  margin: 0 12px;
  color: #fff;
  white-space:nowrap;
}
.popover-header{
  border-radius: 4px 4px 0 0;
  height: 70px;
  box-sizing: border-box;
  color: #fff;
  padding: 13px 16px 11px;
  .popover-header-title{
    line-height: 22px;
    padding-bottom: 4px;
  }
  .recharge{
    width: 50px;
    height: 20px;
    padding: 0;
    border: none;
  }
}
.popover-header-blue{
  background: linear-gradient(269.98deg, #C9E2FF -1.13%, #6EC8FF -1.12%, #3E9DFE 99.98%);
  .recharge{
    background-color: #FC9957;
    color: #fff;
  }
  .recharge:hover{
    background-color: #FC9957;
  }
}
.popover-header-red{
  background: linear-gradient(269.98deg, #FF8E87 -1.13%, #FE6E65 89.2%);
  .recharge{
    background-color: #FFEBEB;
    color: #FA7F3A;
  }
  .recharge:hover{
    background-color: #FFEBEB;
  }
}

.popover-order{
  padding: 12px 16px;
  border-bottom: 1px solid #E4E5E6;
  .popover-order-item{
    line-height: 17px;
  }
  .popover-order-item+.popover-order-item{
    margin-top: 9px;
  }
}
.popover-btn{
  cursor:pointer;
  height: 40px;
  padding: 0 16px;
  color: #333;
  display: flex;
  align-items: center;
  .iconfont{
    margin-right: 13px;
    color: #CECECE;
  }
}
.popover-btn+.popover-btn{
  border-top: 1px solid #E4E5E6;
}
.popover-btn:hover{
  background-color: #f3f3f3;
}
.reference{
  color: white;
  cursor:pointer;
}
</style>